import React from "react";

/**
 * The dashboard's one top bar (DashboardNav) and the two places a page can put
 * things in it: `title`, its left side (ChartMind's steps, a page name), and
 * `actions`, the page's icons just before the app switcher and avatar every page
 * shares. Fill them with TopBarTitle / TopBarActions, which portal into these
 * nodes, so the bar changes with the page without a second bar under it.
 *
 * null outside the dashboard, where there is no bar.
 */
export const TopBarContext = React.createContext(null);
